export default "__VITE_ASSET__BCJkMpUb__"